<template>
  <div class="aiReportForm">
    <div v-if="checkItemName.indexOf('动脉瘤')!== -1">
      <span style="font-size:16px;margin-right:10px;">瘤子个数</span>
      <Select style="width: 120px" :value="tumourNum.toString()" @select="selectTumourNum">
        <Option value="1">1</Option>
        <Option value="2">2</Option>
        <Option value="3">3</Option>
        <Option value="4">4</Option>
        <Option value="5">5</Option>
      </Select>
    </div>
    <div class="moduleWrap" v-for="(reportModule, key) in reportData" :key="key">
      <h1 class="moduleTitle">{{key}}</h1>
      <!-- :class="{moduleFlex: item.style == 'flex'}" -->
      <div class="moduleItem" >
        <div v-for="(sonParams, sIndex) in reportModule" :key="sIndex" class="itemContent" :class="{showBlock: key =='上传3D文件'? 'showBlock': ''}">
          <Divider v-if="sIndex > 0">第{{sIndex + 1}}个瘤子</Divider>
          <div v-for="(item, title) in sonParams" :key="title">
            <div v-for="(child, cIndex) in item" :key="cIndex">
              <div class="subTitle">
                <span style="margin-right:10px;">{{child.label? child.label:title}}</span>
                <span style="color:red;" v-if="child.imageSize">(图片大小：{{child.imageSize}})</span>
              </div>
              <!-- 文本域 -->
              <div class="textAreaWrap" v-if="child.type ==='textArea'">
                <TextArea placeholder="请填写评估结论" :autoSize="{ minRows: 6, maxRows: 6 }" style="width:720px;" allow-clear class="textArea" v-model="child.inputVal"/>
              </div>
              <!-- 下拉选择 -->
              <div v-if="child.type ==='select'">
                <Select style="width: 240px" v-model="child.inputVal">
                  <Option v-for="(val, sindex) in child.selectItems" :key="sindex" :value="val" >{{val}}</Option>
                </Select>
              </div>
              <!-- 仅文件 -->
              <div class="onlyFile" v-if="child.type ==='onlyFile'">
                <div class="onlyFileUpload">
                  <Upload class="uploadFileCom"  :before-upload="(file, fileList) => {uploadObjFile(file,key,sIndex,title,cIndex); return false;}" handleChange   list-type="picture-card"  :show-upload-list="false" allow-clear>
                    <div>
                      <Icon :type="child.loading? 'loading': 'plus'" />
                      <div class="ant-upload-text">点击上传文件</div>
                    </div>
                  </Upload>
                  <div v-if="child.files && child.files.length > 0" class="objFilesWrap">
                    <div v-for="(objFile, objIndex) in child.files" :key="objIndex" class="objFile" @click="downLoadObj(key,sIndex,title,cIndex, objIndex)">
                      <div>
                        <Icon type="file" style="font-size:20px; color:#1890ff;"/>
                        <p v-if="objFile">{{objFile.name}}</p>
                      </div>
                      <Icon type="close-circle" style="position:absolute;right:-8px;top:-8px;cursor:pointer;font-size:18px;" @click="objFielDel(key,sIndex,title,cIndex, objIndex)"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="onlyImage" v-if="child.type ==='onlyImage'">
                <div class="pasteImage" v-for="(imageItem, numIndex) in child.imageList" :key="numIndex" v-on:paste="selectPaste(key,sIndex,title,cIndex,numIndex, $event)">
                  <div class="pasteTip" v-if="imageItem['name'] == 'addImageSeize'" @click.stop="dynamicAddImage(numIndex, child.imageList)">
                    <Icon type="plus" style="font-size:60px;"/>
                    <span style="margin-top:8px;">点击添加多张图片</span>
                  </div>
                  <div class="pasteTip"  v-else-if="!imageItem['url']">
                    <Icon type="picture" style="font-size:60px;"/>
                    <span style="margin-top:8px;">将图片按Ctrl+V 粘贴至此处</span>
                  </div>
                  <div class="imageWrap" v-else>
                    <img :src="imageItem['url']"/>
                    <div class="delAndPrev">
                      <Icon type="eye" style="font-size:30px; margin-right:15px;" @click="previewImage(key,sIndex,title,cIndex,numIndex)"/>
                      <Icon type="delete" style="font-size:30px;" @click="deleteImage(key,sIndex,title,cIndex,numIndex)"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="numAndImage" v-if="child.type === 'numAndImage'">
                <div class="inputVal">
                  <Input :placeholder="'请输入'+ (child.label? child.label : title)" v-model="child.inputVal" style="margin-bottom:10px;" :addon-after="child.valUnit"/>
                </div>   
                <div class="pasteImage" v-for="(imageItem, numIndex) in child.imageList" :key="numIndex" v-on:paste="selectPaste(key,sIndex,title,cIndex,numIndex, $event)">
                  <div class="pasteTip" v-if="!imageItem.url">
                    <Icon type="picture" style="font-size:60px;"/>
                    <span style="margin-top:8px;">将图片按Ctrl+V 粘贴至此处</span>
                  </div>
                  <div class="imageWrap" v-else>
                    <img :src="imageItem.url"/>
                    <div class="delAndPrev">
                      <Icon type="eye" style="font-size:30px; margin-right:15px;"  @click="previewImage(key,sIndex,title,cIndex,numIndex)"/>
                      <Icon type="delete" style="font-size:30px;" @click="deleteImage(key,sIndex,title,cIndex,numIndex)"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="onlyNum" v-if="child.type === 'onlyNum'">
                <Input :placeholder="'请输入'+ (child.label? child.label : title) " v-model="child.inputVal" style="margin-bottom:10px;" :addon-after="child.valUnit"/>
              </div>
              <div class="textAndImage" v-if="child.type === 'textAndImage'">
                <div class="pasteImage" v-for="(imageItem, numIndex) in child.imageList" :key="numIndex" v-on:paste="selectPaste(key,sIndex,title,cIndex,numIndex, $event)">
                  <div class="pasteTip" v-if="!imageItem['url']">
                    <Icon type="picture" style="font-size:60px;"/>
                    <span style="margin-top:8px;">将图片按Ctrl+V 粘贴至此处</span>
                  </div>
                  <div class="imageWrap" v-else >
                    <img :src="imageItem['url']" />
                    <div class="delAndPrev">
                      <Icon type="eye" style="font-size:30px; margin-right:15px;" @click="previewImage(key,sIndex,title,cIndex,numIndex)"/>
                      <Icon type="delete" style="font-size:30px;" @click="deleteImage(key,sIndex,title,cIndex,numIndex)"/>
                    </div>
                  </div>
                </div>
                <div class="textVal">
                  <TextArea placeholder="请输入分析结论" v-model="child.inputVal" style="margin-bottom:10px;"/>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>
<script>
import { Input, Icon, Upload, Select, Divider } from 'ant-design-vue'
import { downLoadFile, isNullOrUndefined, toast } from '../../libs/utils'
import { checkReportFile, upLoadAiReportFile } from '../../api/report'
import { cloneDeep } from 'lodash'
import { api as viewerApi } from 'v-viewer'

let reportTemplate  = {}
export default {
  props: {
    reportId: {
      type: Number
    },
    reportParams: {
      type: String,
      default: ''
    },
    checkItemName: {
      type: String,
      default: ''
    }
  },
  components: {
    TextArea: Input.TextArea,
    Icon,
    Input,
    Upload,
    Select,
    Option: Select.Option,
    Divider
  },
  async mounted() {
    if (this.checkItemName.indexOf('冠心病')!== -1) {
      reportTemplate = require('../../config/aiReportFormTp/guanxb_specialty').default
    } else if (this.checkItemName.indexOf('动脉瘤')!== -1) {
      reportTemplate = require('../../config/aiReportFormTp/dml_specialty').default
    } else if (this.checkItemName.indexOf('脑健康')!== -1) {
      reportTemplate = require('../../config/aiReportFormTp/njk_specialty').default
    } else {
      reportTemplate = require('../../config/aiReportFormTp/lsjxg_specialty').default
    }
    if (!this.reportParams) this.reportData = cloneDeep(reportTemplate.dataTemplate)
    if (this.reportParams) {
      let jsonObj = null
      try {
        jsonObj = JSON.parse(this.reportParams)
      } catch (error) {
        throw Error('解析JSON错误')
      }
      this.formatData(jsonObj)
    }
  },
  data() {
    return {
      tumourNum: 1,
      reportData: ''
    }
  },
  methods: {
    formatData(jsonObj) {
      this.reportData = reportTemplate.parseJsonObj(jsonObj)
    },
    async selectPaste(key,sIndex,title,cIndex, numIndex, event) {
      if (isNullOrUndefined(key) || isNullOrUndefined(sIndex) || isNullOrUndefined(title) || isNullOrUndefined(cIndex) || isNullOrUndefined(numIndex)) return toast({msg: '请先点击要黏贴图片的位置'})
      let items = event.clipboardData && event.clipboardData.items
      let file = null
      if (!items || items.length === 0) return toast({msg: '黏贴图片错误，请重新试试'})
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) return toast({msg: '粘贴内容非图片'})
      let imageTarget = this.reportData[key][sIndex][title][cIndex]['imageList'][numIndex]
      let url = await upLoadAiReportFile({
        reportId: 1 * this.reportId,
        fileName: imageTarget['name'],
        file: file,
        materialsNum:  1 + sIndex
      })
      if (url) imageTarget.url = url
    },
    deleteImage(key,sIndex,title,cIndex,numIndex) {
      if (isNullOrUndefined(key) || isNullOrUndefined(sIndex) || isNullOrUndefined(title) || isNullOrUndefined(cIndex) || isNullOrUndefined(numIndex)) return toast({msg: '获取参数错误'})
      let imageTarget = this.reportData[key][sIndex][title][cIndex]['imageList'][numIndex]
      if (imageTarget) imageTarget.url = ''
    },
    async uploadObjFile(file, key,sIndex,title,cIndex) {
      let target = this.reportData[key][sIndex][title][cIndex]
      target.loading = true
      let uploadData = await upLoadAiReportFile({
        reportId: 1 * this.reportId,
        fileName: target.name + '_'+ `${target.files.length + 1}`,
        file: file
      })
      if (uploadData) {
        target.files.push({name: file.name, url:uploadData})
      }
      target.loading = false
      return false
    },
    objFielDel(key,sIndex,title,cIndex, objIndex) {
      let target = this.reportData[key][sIndex][title][cIndex]
      target['files'].splice(objIndex, 1)
    },
    createSubmitParams() {
      return reportTemplate.createParams(this.reportData)
    },
    checkImageAndInputVal(item, key) {
      if (item.hasOwnProperty('fileList')) {
        for (let i = 0; i < item.fileList.length; i++) {
          let fileItem = item.fileList[i]
          if (fileItem.files.length < 1) {
            toast({msg: `请上传${fileItem.tip}文件`})
            return false
          }
        }
      } 
      if (item.hasOwnProperty('imageList')) {
        for (let j = 0; j < item.imageList.length; j++) {
          let fileItem = item.imageList[j]
          if (fileItem.name =='addImageSeize') continue
          if (!fileItem.url) {
            toast({msg: `请上传${key}图片`})
            return false
          }
        }
      }
      if (item.hasOwnProperty('inputVal')) {
        if (!item.inputVal.trim()) {
          toast({msg: `${key}不能为空`})
          return false
        } 
       
      }
      return true
    },
    async submitParams() {
      // 校验参数和封装传入参数
      for(let k in this.reportData) {
        let module = this.reportData[k]
        for(let i = 0; i < module.length; i++) {
          let tumour = module[i]
          for (let j in tumour) {
            let detailItem = tumour[j]
            for (let m = 0; m < detailItem.length; m++) {
              let targetItem = detailItem[m]
              if (!this.checkImageAndInputVal(targetItem, j)) return false
            }
          }
        }
      }
      let fileParam = this.createSubmitParams()
      if (!fileParam) return false
      let lastParams = {
        reportType: reportTemplate.reportType,
        reportId: this.reportId,
        fileParam: fileParam
      }
      return await checkReportFile(lastParams)
    },
    previewImage(key,sIndex,title,cIndex,numIndex) {
      if (isNullOrUndefined(key) || isNullOrUndefined(sIndex) || isNullOrUndefined(title) || isNullOrUndefined(cIndex) || isNullOrUndefined(numIndex)) return toast({msg: '获取参数错误'})
      let imageTarget = this.reportData[key][sIndex][title][cIndex]['imageList'][numIndex]
      if (imageTarget) viewerApi({ images: [imageTarget.url]})
    },
    downLoadObj(key,sIndex,title,cIndex, objIndex) {
      let target = this.reportData[key][sIndex][title][cIndex]
      target['files'].splice(objIndex, 1)
      downLoadFile(target['files'][objIndex]['url'], target['files']['name'])
    },
    selectTumourNum(value) {
      if (value > this.tumourNum) {
        let cloneTarget = cloneDeep(reportTemplate.dataTemplate['形态学指标分析'][0])
        if (this.reportData['形态学指标分析'].length >= value) return false
        let addNum = value - this.reportData['形态学指标分析'].length
        for(let i = 0; i < addNum; i++) {
          this.reportData['形态学指标分析'].push(cloneTarget)
        }
      } else {
        for(let i = 0; i < this.tumourNum - value; i++)
          this.reportData['形态学指标分析'].pop()
      }
      this.tumourNum = value
    },
    dynamicAddImage(numIndex, imageList) {
      let lastImageItem = imageList[imageList.length - 2]
      let copyItem = cloneDeep(lastImageItem)
      copyItem.url = ''
      imageList.splice(numIndex, 0, copyItem)
    }
  }
}
</script>
<style lang="less">
.aiReportForm{
  .moduleWrap{
    .ant-divider{
      font-size: 18px;
    }
    .moduleTitle{
      font-size: 20px;
      color: #47a271;
    }
    .moduleItem{
      border: 1px solid rgb(190, 189, 189);
      padding: 12px 20px;
      margin-bottom: 12px;
    }
    .subTitle{
      font-size: 16px;
      color: #333;
      margin-bottom: 8px;
    }
  }
  .title{
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
  }
  .showBlock{
    display: block !important;
  }
  .textAreaWrap{
    width: 100%;
  }
  .textArea{
    height: 150px;
  }
  .onlyImage{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .numAndImage{
    .inputVal{
      width: 350px;
    }
  }
  .onlyNum{
    width: 350px;
  }
  .onlyFile{
    .onlyFileUpload{
      display: flex;
      flex-wrap: wrap;
       .uploadFileCom{
        display: flex;
      }
      .ant-upload-picture-card-wrapper{
        width: auto;
      }
      .objFilesWrap{
        display: flex;
        flex-wrap: wrap;
        .objFile{
          position:relative;
          width:104px;
          height:104px;
          justify-content: center;
          display:flex;
          align-items: center;
          border: 1px dashed #d9d9d9;
          border-radius: 4px;
          text-align: center;
          vertical-align: middle;
          margin-right: 12px;
          &:hover{
            border-color: #1890ff;
          }
        }
        
      }
    } 
  }
  .pasteImage{
    width: 350px;
    border: 1px dashed #ccc;
    height: 200px;
    margin-bottom: 12px;
    overflow: hidden;
    &:hover{
      border-color: #1890ff;
      cursor: pointer;
    }
    .imageWrap{
      overflow: hidden;
      position: relative;
      height: 100%;
      img{
        width: 100%;
        object-fit: cover;
      }
      .delAndPrev{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: 100;
        background-color: rgba(0,0,0,.5);
        display: none;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
      &:hover .delAndPrev{
        display: flex;
      }
    }
    .pasteTip{
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      color: #999;
      &:hover{
        color: #1890ff;
      }
    }
  }
  .textAndImage{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .textVal{
      width: 100%;
    }
  }
  .itemContent{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .moduleFlex{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .itemContent{
      width: 350px;
      margin-right: 20px;
    }
    .itemContent:nth-child(even){
      margin-right: 0;
    }
  }
}
</style>